<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="noticeIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>通知公告</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="notice_banner" >
            <el-carousel :interval="5000" arrow="always">
              <el-carousel-item v-for="(item,index) in hotData" :key="index">
                <div style="height:300px;border-radius: 10px;">
                  <div style="width: 300px;height:300px;background-color: #303030;opacity: 0.7;color: white;position: absolute;z-index: 999;right: 0px;border-radius: 0 10px 10px 0;display: flex;flex-flow: column;justify-content: space-between;">
                   <div style="width: 100%;margin-top: 20px;">
                    <div style="font-size: 16px;line-height: 30px;width: 90%;margin: 0 auto;">{{item.title}}</div>
                    <div style="font-size: 13px;line-height: 22px;width: 90%;margin: 0 auto;margin-top: 30px;">{{item.remark}}</div>
                   </div>
                    <div style="display: flex;justify-content: space-between;width: 90%;margin: 0 auto;font-size: 13px;margin-bottom: 20px;"><div>{{item.time}}</div><div style="cursor: pointer" @click="urlTo('NoticeDetail',{detail_id:item.id})">查看详细-></div></div>
                  </div>
                  <div style="position: relative; height:300px;z-index: 998;border-radius: 10px;">
                    <!--<img src="../../static/images/gg_two.png" style="height: 300px;">-->
                    <img :src="getImg(item.data_pic_url_one)" style="height: 300px;">
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="notice_con">
            <h2 class="tit tit2">通知公告</h2>
            <ul>
              <li  v-for="(item,index) in listData" :key="index" @click="urlTo('NoticeDetail',{detail_id:item.id})">
                <a href="javascript:void(0)">
                <dt><h3>{{item.day}}</h3><p>{{item.yearMonth}}</p></dt>
                <dd >
                  <div  style="white-space:nowrap">
                  <h4>{{item.title | ellipsisTitle}} <span style="float: right;color: #9d9d9d;font-size: 14px">发布单位：{{item.data_author}}</span></h4>

                  </div>
                  <div style="width:710px;height:48px;    color: #888888;line-height:24px;font-size: 12px;overflow:hidden;text-overflow:ellipsis">{{item.remark }}</div>
                </dd>
              </a>
              </li>
            </ul>
            <div class="clear"></div>

          </div>
        </div>
        <div class="page">     <el-pagination
          layout="prev, pager, next"
          :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
        </el-pagination>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
import headers from "../components/Headers";
import fixedDiv from "../components/FixedDiv";
import footers from "../components/Footer";
export default {
  name: "public-index",
  components:{
    headers,fixedDiv,footers
  },
  data() {
    let _self=this;
    return {
      active: 'noticeIndex',
      width:document.body.clientWidth+'px',
      height:document.body.clientHeight+'px',
      pageNum:1,
      pageSize:6,
      pageTotal:0,
      hotData:[],
      listData:[],
    }
  } ,
  filters: {
    ellipsis (value) {
      if (!value) return ''
      if (value.length > 120) {
        return value.slice(0,120) + '...'
      }
      return value
    },
    ellipsisTitle (value) {
      if (!value) return ''
      if (value.length > 39) {
        return value.slice(0,39) + '...'
      }
      return value
    }

  },
  watch: {
    width(n,o){
      alert(n+'w')
    },
    height(n,o){
      alert(n+'h')
    },
  },
  created(){
    this.initData();
  },
  methods: {
    getImg(imgId){
      var dd=this.$util.req.getshowImg(imgId);
      return dd;
    },
    prevClick(a){
      this.pageNum=this.pageNum-1;
      this.initData();
    },
    nextClieck(a){
      this.pageNum=this.pageNum+1;
      this.initData();
    },
    pageChange(a){
      this.pageNum=a
      this.initData();
    },
    initData(){
      this.$https.post("api/pu/info/listTzggList.do",{pageNum:this.pageNum,pageSize:this.pageSize,ic_code:'400'},response=> {
        if (response.status === 200 && response.data.code === 200) {
          if(response.data.data.hot && response.data.data.hot.length>0){
            this.hotData=response.data.data.hot;
          }
          if(response.data.data.list && response.data.data.list.length>0){
            this.listData=response.data.data.list;
          }
          if(response.data.data.total){
            this.pageTotal=parseInt(response.data.data.total+"");
          }
        }
      });
    },
    urlTo(url,params){
      this.$router.push({path:url,query:params||{}});
    }
  }
}



</script>



// WEBPACK FOOTER //
// src/pages/NoticeIndex.vue